import startCase from 'lodash/startCase';
import qs from 'query-string';

const CUSTOM_PARAM_PREFIX = ['perspective_', 'ps_'];
export const UTM_PARAM_IDS = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_term',
    'utm_content',
] as const;
const KNOWN_PARAM_IDS = [...CUSTOM_PARAM_PREFIX, ...UTM_PARAM_IDS];

const getQueryParameter = () => {
    const queryParams = window.location.search.substr(1);

    return _getQueryParameter(queryParams);
};

export const _getQueryParameter = (queryString: string) => {
    const utm: Record<string, string> = {};
    const custom: Record<string, string> = {};
    const thirdParty: Record<string, string> = {};
    const additionalTrackingTitles: Record<string, string> = {};
    const queryParams = qs.parse(queryString);

    UTM_PARAM_IDS.forEach((utmParam) => {
        if (queryParams[utmParam]) {
            utm[utmParam] = toStringValue(queryParams[utmParam]);
        }
    });

    CUSTOM_PARAM_PREFIX.forEach((customIdentifier) => {
        Object.keys(queryParams)
            .filter((queryParam) => {
                if (UTM_PARAM_IDS.indexOf(queryParam as (typeof UTM_PARAM_IDS)[number]) > -1) {
                    return false;
                }

                return queryParam.indexOf(customIdentifier) === 0;
            })
            .forEach((param) => {
                const name = param.substr(customIdentifier.length);

                if (queryParams[param]) {
                    custom[name] = toStringValue(queryParams[param]);
                }
                additionalTrackingTitles[name] = sanitizeTrackingTitles(name);
            });

        Object.keys(queryParams)
            .filter((queryParam) => {
                return (
                    KNOWN_PARAM_IDS.filter((checkParam) => {
                        return queryParam.indexOf(checkParam) > -1;
                    }).length === 0
                );
            })
            .forEach((queryParam) => {
                if (queryParams[queryParam]) {
                    thirdParty[queryParam] = toStringValue(queryParams[queryParam]);
                }
                additionalTrackingTitles[queryParam] = sanitizeTrackingTitles(queryParam);
            });
    });

    return { utm, custom, thirdParty, additionalTrackingTitles };
};

const toStringValue = (value: string | (string | null)[] | null): string => {
    if (Array.isArray(value)) {
        return value.join(', ');
    }
    return value ?? '';
};

const sanitizeTrackingTitles = (propertyName: string) => {
    const readablePropertyName = propertyName.replace(/-/g, ' ').replace(/_/g, ' ');

    return startCase(readablePropertyName);
};

export default getQueryParameter;
